import { render, staticRenderFns } from "./EmployeeSalarySettingForm.vue?vue&type=template&id=91151b12&"
import script from "./EmployeeSalarySettingForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports